import { NormalizeMap } from './types';

// normalizing request fields to prevent unnecessary hit misses
export const normalizedKeyMap: Record<string, NormalizeMap> = {
  teamID: { contains: [''], to: undefined }
};
